import React from "react";
import { Badge, Button, Form } from "react-bootstrap";
import "./tabla.css";

const ROLE_LABELS = {
  Promotor: "EDM",
  Vendedor: "Vendedor",
};

export default function Account(props) {
  const roleLabel = ROLE_LABELS[props.role] ?? props.role;

  return (
    <tr key={props.id}>
      <td>
        <span>{props.num}</span>
      </td>
      <td>
        <span>{props.nombre_completo}</span>
      </td>
      <td>
        <span>{props.dealer_id}</span>
      </td>
      {props.onRoleChange && (
        <td>
          <div className="d-flex flex-column align-items-start gap-1">
            <Badge
              bg={props.role === "Promotor" ? "info" : "success"}
              className="px-2 py-1"
            >
              {roleLabel}
            </Badge>
            <Form.Select
              size="sm"
              value={props.role === "Promotor" ? "Promotor" : "Vendedor"}
              onChange={(e) =>
                props.onRoleChange(props.id, e.target.value, props.nombre_completo)
              }
              aria-label={`Cambiar rol de ${props.nombre_completo}`}
              style={{ minWidth: "110px" }}
            >
              <option value="Vendedor">Vendedor</option>
              <option value="Promotor">EDM</option>
            </Form.Select>
          </div>
        </td>
      )}
      <td>
        <span>
          <Button
            variant="info"
            onClick={() => props.handleModal(props.id)}
            className="btn-bg--orange"
          >
            Información
          </Button>
        </span>
      </td>
      <td>
        <span>
          <Form>
            <Form.Check
              type="switch"
              id={`custom-switch-${props.id}`}
              label="Activar"
              value={props.status}
              checked={props.status ? 1 : 0}
              onChange={(e) => props.onActive(props.id, e.target.value)}
            />
          </Form>
        </span>
      </td>
      <td>
        <Form>
          <Button variant="info mt-2" onClick={() => props.onAddNote(props.id)}>
            Editar Nota
          </Button>
        </Form>
      </td>
      <td>{props.nota}</td>
      <td>
        <span>{props.created_at}</span>
      </td>
      {props.onResetPassword && (
        <td>
          <Button
            size="sm"
            className="btn-soft-yellow"
            onClick={() => props.onResetPassword(props.id)}
          >
            Recuperar contraseña
          </Button>
        </td>
      )}
    </tr>
  );
}
